//
//
//
//
//
//
//
//
//
//

import NsRadioGroup from '../../NsRadioGroup.vue';
import { PropsMixin, ModelMixin } from '../mixins';

export default {
  components: {
    NsRadioGroup,
  },
  mixins: [PropsMixin, ModelMixin({ deep: false })],
  props: {
    /**
     * Field value
     * @type {object}
     */
    value: {
      type: [Boolean, String, Number],
      default: null,
    },
  },
  computed: {
    requiredMessage() {
      // The AEM service sets up a validation rule with this regex if the field is required.
      const requiredRegex = '/^[^]+$/';
      // Since the regex doesn't work well with a boolean value, we extract
      // the error message from the validation rule. We'll set up a rule which uses
      // the message.
      const validation = this.schema.validation || [];
      const requiredRule = validation.find(
        ({ regex }) => regex === requiredRegex
      );
      return requiredRule ? requiredRule.error : null;
    },
    rules() {
      const requiredMessage = this.requiredMessage;
      if (requiredMessage) {
        return [(value) => value || requiredMessage];
      } else {
        return [];
      }
    },
  },
};
